import { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { categories } from '@/mocks/comics';

export default function Navbar() {
  const [isScrolled, setIsScrolled] = useState(false);
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const [categoryOpen, setCategoryOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 20);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  useEffect(() => {
    setMobileMenuOpen(false);
    setCategoryOpen(false);
  }, [location]);

  return (
    <nav
      className={`fixed top-0 left-0 w-full z-50 transition-all duration-300 ${
        isScrolled
          ? 'bg-background-50/95 backdrop-blur-md border-b border-background-200/70'
          : 'bg-transparent'
      }`}
    >
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="flex items-center justify-between h-16">
          <Link
            to="/"
            className="flex items-center gap-2 font-heading text-2xl font-bold text-foreground-900 whitespace-nowrap cursor-pointer"
          >
            <span className="w-9 h-9 flex items-center justify-center bg-primary-500 text-background-50 rounded-lg">
              <i className="ri-book-open-line text-lg"></i>
            </span>
            <span>奇漫屋</span>
          </Link>

          <div className="hidden md:flex items-center gap-8">
            <Link
              to="/"
              className={`text-sm font-medium whitespace-nowrap cursor-pointer transition-colors ${
                location.pathname === '/'
                  ? 'text-primary-500'
                  : 'text-foreground-700 hover:text-primary-500'
              }`}
            >
              首页
            </Link>

            <div className="relative">
              <button
                onClick={() => setCategoryOpen(!categoryOpen)}
                className={`flex items-center gap-1 text-sm font-medium whitespace-nowrap cursor-pointer transition-colors ${
                  location.pathname.startsWith('/category')
                    ? 'text-primary-500'
                    : 'text-foreground-700 hover:text-primary-500'
                }`}
              >
                分类
                <i className={`ri-arrow-down-s-line text-sm transition-transform ${categoryOpen ? 'rotate-180' : ''}`}></i>
              </button>

              {categoryOpen && (
                <>
                  <div className="fixed inset-0 z-10" onClick={() => setCategoryOpen(false)}></div>
                  <div className="absolute top-full left-0 mt-2 w-48 bg-background-50 border border-background-200/80 rounded-lg py-2 z-20">
                    {categories.filter(c => c.slug !== 'all').map((cat) => (
                      <Link
                        key={cat.slug}
                        to={`/category/${cat.slug}`}
                        className="flex items-center gap-3 px-4 py-2.5 text-sm text-foreground-700 hover:bg-background-100 hover:text-primary-500 transition-colors cursor-pointer whitespace-nowrap"
                      >
                        <span className="w-4 h-4 flex items-center justify-center">
                          <i className={`${cat.icon} text-sm`}></i>
                        </span>
                        {cat.name}
                      </Link>
                    ))}
                  </div>
                </>
              )}
            </div>

            <Link
              to="/about"
              className={`text-sm font-medium whitespace-nowrap cursor-pointer transition-colors ${
                location.pathname === '/about'
                  ? 'text-primary-500'
                  : 'text-foreground-700 hover:text-primary-500'
              }`}
            >
              关于我们
            </Link>
          </div>

          <div className="flex items-center gap-3">
            <button
              className="hidden md:flex items-center gap-2 px-4 py-2 bg-primary-500 text-background-50 text-sm font-medium rounded-lg cursor-pointer hover:bg-primary-600 transition-colors whitespace-nowrap"
            >
              <i className="ri-search-line"></i>
              搜索
            </button>

            <button
              className="md:hidden w-10 h-10 flex items-center justify-center text-foreground-700 cursor-pointer"
              onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
            >
              <i className={`text-xl ${mobileMenuOpen ? 'ri-close-line' : 'ri-menu-line'}`}></i>
            </button>
          </div>
        </div>
      </div>

      {mobileMenuOpen && (
        <div className="md:hidden bg-background-50 border-t border-background-200/70">
          <div className="px-4 py-4 space-y-1">
            <Link
              to="/"
              className="block px-3 py-2.5 text-sm font-medium text-foreground-700 hover:bg-background-100 rounded-lg cursor-pointer"
            >
              首页
            </Link>
            {categories.filter(c => c.slug !== 'all').map((cat) => (
              <Link
                key={cat.slug}
                to={`/category/${cat.slug}`}
                className="flex items-center gap-3 px-3 py-2.5 text-sm text-foreground-700 hover:bg-background-100 rounded-lg cursor-pointer"
              >
                <span className="w-4 h-4 flex items-center justify-center">
                  <i className={`${cat.icon} text-sm`}></i>
                </span>
                {cat.name}
              </Link>
            ))}
            <Link
              to="/about"
              className="block px-3 py-2.5 text-sm font-medium text-foreground-700 hover:bg-background-100 rounded-lg cursor-pointer"
            >
              关于我们
            </Link>
          </div>
        </div>
      )}
    </nav>
  );
}